import React from "react"

import { Tooltip, Container, Row, Col } from "reactstrap"
import Link from "../components/link"
import Button from "../components/btn"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { 
  FaCode, 
  FaGithub, 
  FaBolt, 
  FaHome, 
  FaHandsHelping, 
  FaDigitalOcean,
  FaDocker,
  FaUbuntu,
  FaJava,
  FaLaravel,
  FaNpm,
  FaNode,
  FaPhp,
  FaPython,
  FaReact,
  FaHtml5,
  FaJs,
  FaCss3Alt,
  FaBootstrap,
  FaAndroid,
  FaAppStore,
  FaWindows,
  FaGitlab,
  FaWordpress,
  FaAngular
 } from "react-icons/fa"
import { 
  DiLinux,
  DiNginx,
  DiMysql,
  DiJoomla,
  DiCodeigniter,
  DiComposer,
  DiDotnet,
  DiBitbucket,
  DiPostgresql,
  DiJenkins
 } from "react-icons/di";
import { 
  SiOracle,
  SiAdobe,
  SiPostman
 } from "react-icons/si";

import Form from "../components/form"
import Slider from "../components/slider"
import Box from "../components/box"
import Hr from "../components/hr"
import Benefits from "../components/benefits"
import styled from "styled-components"
import HomeFeatures from "../components/homeFeatures"
import Testimonials from '../components/testimonials'
import laravelLogo from "../assets/images/laravel-certificate-2022-logo-grey-label.svg"
import zebra from "../assets/images/zebra.png"
import oracle from "../assets/images/oracle.webp"
import fourtwoq from "../assets/images/42q.png"
import fourtwoqjpg from "../assets/images/42q.jpg"
// import laravelLogo from "../assets/images/laravel-certificate-2022-logo-white-black-label.svg"
// import laravelLogo from "../assets/images/laravel-certificate-2022-logo-grey-black-label.svg"


let StyledBackground = styled.div`
  background: linear-gradient(to bottom, #f9fbfd 0, #fff 100%);
`

let LaravelCertBackground = styled.div`
  background: rgb(98,11,11);
  background: linear-gradient(0deg, rgba(98,11,11,1) 30%, rgba(158,21,30,1) 100%);
  padding-top:100px;
  // clip-path: polygon(0px 0px, 100% 0px, 100% 85%, 0% 100%);
  clip-path: polygon(0 10%, 100% 0, 110% 100%, 0% 100%);
  // clip-path: polygon(0 0, 100% 10%, 100% 90%, 0% 100%);
`

let ZebraBackground = styled.div`
  background: rgb(19, 12, 97);
  background: linear-gradient(0deg, rgba(19, 12, 97) 30%, rgba(98,11,11) 100%);
  padding-top:100px;
  margin-top: -10px;
  // clip-path: polygon(0px 0px, 100% 0px, 100% 85%, 0% 100%);
  clip-path: polygon(0 0, 100% 0, 100% 90%, 0% 100%);
  // clip-path: polygon(0 0, 100% 10%, 100% 90%, 0% 100%);
`

const HoverText = styled.p`
  color: #b7b7b7;
  :hover {
    color: darkslateblue;
    cursor: pointer;
  }
`

let Service = ({ title, description, Icon = FaHome, example }) => (
  <Col xs={12} md={4} className="mb-3">
      <Box>
        <Icon size={40} style={{display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color:"white", backgroundColor: '#A00429'}}/>
        <h4 className="mt-3">{title}</h4>
        <p className="mt-3">{description}</p>
        <p className="mt-3">{example}</p>
      </Box>
  </Col>
)

let Technology = ({ title, description, Icon = FaHome, example }) => (
  <Col xs={3} md={3} className="mb-3 d-flex justify-content-center">
    <div className="text-center">
      <HoverText><Icon size={60} /></HoverText>
      <p>{title}</p>
    </div>
    
  </Col>
)

let Index = () => (
  <Layout>
    <SEO title="Home" />
    <Slider />
    <Container className="pt-4">
      <div className="text-center">
        <h4>Building the right digital and valuable solutions for you</h4>
        <p className="text-muted">
          An experienced and reliable partner
        </p>
      </div>
    </Container>
    <Container className="py-5">
      <h2 className="text-center mb-4" style={{fontWeight:'900'}}>Services</h2>
      <Row>
        <Service title="Software Development" Icon={FaCode} description="We have developed off-the-shelf software product that could be further customized to suit your organization needs."/>
        <Service title="Solution Integration" Icon={FaBolt} description="We concentrate in providing IT solutions, while our partners take care of the financial and engagement matters. The expertise to assist in designing the appropriate network setup for your organisation and implement it in a timely manner."/>
        <Service title="Solutions Reseller" Icon={FaHandsHelping} description="We are an authorised reseller of High Speed Broadband Services from TIME dotCOM, Maxis, Celcom and TM. We are also authorized reseller and business partner of Exabytes Malaysia."/>
      </Row>
    </Container>
    
    <LaravelCertBackground>
      <Container className="py-5">
      {/* <h2 className="text-center mb-4 text-white" style={{fontWeight:'900'}}>We are the first Malaysian company to be registered and recognised as a Laravel Certified Company</h2> */}
        <div className="text-center pb-5">
          <img src={laravelLogo} alt="Laravel Cert Logo" className="mx-3" style={{maxWidth: '330px', minWidth: '330px'}}/>
        </div>
        <h2 className="text-center mb-4 pt-4 text-white" style={{fontWeight:'900'}}><span>&nbsp;&nbsp;We are the first Malaysian company to be registered and recognised as a Laravel Certified Company&nbsp;&nbsp;</span></h2>
        {/* <h2 className="text-center mb-4" style={{fontWeight:'900', color:'#620b0b'}}><span style={{background: 'white'}}>&nbsp;&nbsp;and recognised as a Laravel Certified Company&nbsp;&nbsp;</span></h2> */}

        <div className="text-center py-5">
          <Button
            to="https://laravelcert.com/company/two-q-alliance"
            className="btn btn-lg" style={{background:'white', color:'black'}}>
            See more
          </Button>
        </div>
      </Container>
    </LaravelCertBackground>
    
    <ZebraBackground>
      <Container className="py-5">
      {/* <h2 className="text-center mb-4 text-white" style={{fontWeight:'900'}}>We are the first Malaysian company to be registered and recognised as a Laravel Certified Company</h2> */}
        <div className="text-center pb-5">
          <img src={zebra} alt="Zebra Logo" className="mx-3" style={{maxWidth: '330px', minWidth: '330px'}}/>
          <img src={oracle} alt="Oracle Logo" className="mx-3" style={{maxWidth: '330px', minWidth: '330px'}}/>
          <img src={fourtwoq} alt="42Q Logo" className="mx-3" style={{maxWidth: '330px', minWidth: '330px'}}/>

        </div>
        <h2 className="text-center mb-4 pt-4 text-white" style={{fontWeight:'900'}}><span>&nbsp;&nbsp;Officially Oracle Partner and Zebra Registered ISV Partner &nbsp;&nbsp;</span></h2>
        {/* <h2 className="text-center mb-4" style={{fontWeight:'900', color:'#620b0b'}}><span style={{background: 'white'}}>&nbsp;&nbsp;and recognised as a Laravel Certified Company&nbsp;&nbsp;</span></h2> */}

        <div className="text-center py-5">
          <Button
            to="https://www.zebra.com/ap/en/partners/partner-application-locator/partner-details.html?id=0016S000035qoUeQAI"
            className="btn btn-lg" style={{background:'white', color:'black'}}>
            See more
          </Button>
        </div>
      </Container>
    </ZebraBackground>

    <StyledBackground>
      <Benefits />
    </StyledBackground>

    <StyledBackground>
      <Container className="py-5">
        <h2 className="text-center mb-4" style={{fontWeight:'900'}}>Technologies</h2>
        <Row className="d-flex justify-content-center mt-5">
          <Technology title="Digital Ocean" Icon={FaDigitalOcean}/>
          <Technology title="Docker" Icon={FaDocker}/>
          <Technology title="Ubuntu" Icon={FaUbuntu}/>
          <Technology title="Linux" Icon={DiLinux}/>
        </Row>
        <Row className="d-flex justify-content-center">
          <Technology title="Nginx" Icon={DiNginx}/>
          <Technology title="MySQL" Icon={DiMysql}/>
          <Technology title="Java" Icon={FaJava}/>
          <Technology title="Laravel" Icon={FaLaravel}/>
        </Row>
        <Row className="d-flex justify-content-center">
          <Technology title="NPM" Icon={FaNpm}/>
          <Technology title="Node" Icon={FaNode}/>
          <Technology title="Php" Icon={FaPhp}/>
          <Technology title="Python" Icon={FaPython}/>
        </Row>
        <Row className="d-flex justify-content-center">
          <Technology title="Wordpress" Icon={FaWordpress}/>
          <Technology title="Joomla" Icon={DiJoomla}/>
          <Technology title="CodeIgniter" Icon={DiCodeigniter}/>
          <Technology title="Composer" Icon={DiComposer}/>
        </Row>
        <Row className="d-flex justify-content-center">
          <Technology title=".NET" Icon={DiDotnet}/>
          <Technology title="React" Icon={FaReact}/>
          <Technology title="HTML5" Icon={FaHtml5}/>
          <Technology title="JavaScript" Icon={FaJs}/>
        </Row>
        <Row className="d-flex justify-content-center">
          <Technology title="CSS" Icon={FaCss3Alt}/>
          <Technology title="Bootstrap" Icon={FaBootstrap}/>
          <Technology title="Android" Icon={FaAndroid}/>
          <Technology title="iOS" Icon={FaAppStore}/>
        </Row>
        <Row className="d-flex justify-content-center">
          <Technology title="Windows" Icon={FaWindows}/>
          <Technology title="Github" Icon={FaGithub}/>
          <Technology title="Gitlab" Icon={FaGitlab}/>
          <Technology title="BitBucket" Icon={DiBitbucket}/>
        </Row>
        <Row className="d-flex justify-content-center">
          <Technology title="Angular" Icon={FaAngular}/>
          <Technology title="PostgreSQL" Icon={DiPostgresql}/>
          <Technology title="Jenkins" Icon={DiJenkins}/>
          <Technology title="Postman" Icon={SiPostman}/>
        </Row>
        <Row className="d-flex justify-content-center">
          <Technology title="Oracle" Icon={SiOracle}/>
          <Technology title="Adobe" Icon={SiAdobe}/>
        </Row>
      </Container>
    </StyledBackground>

    <StyledBackground>
      <div className="py-5">
        <Container>
          <Row className="d-flex justify-content-center">
            <Col md={8}>
              <Box style={{ textAlign: "left" }}>
                <h3 className="text-center">Contact Us</h3>
                <Hr />
                <Form />
              </Box>
            </Col>
          </Row>
        </Container>
      </div>
    </StyledBackground>
    {/* <HomeFeatures /> */}
    {/* <Testimonials/> */}
  </Layout>
)

export default Index
